import { CheckInState } from './types';

export const state = (): CheckInState => initialState();

export const initialState = (): CheckInState => ({
  courseTrainers: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['CourseName'],
    },
  },
});
